import { SetupStandardStateControlsCommand } from "slotworks/commands/setup/setup-standard-state-controls-command";
import { SoundPromptCommand } from "slotworks/commands/sound/sound-prompt-command";
import Components from "slotworks/components/components";
import AutoplayModel from "slotworks/model/autoplay/autoplay-model";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import SmartUiManager from "slotworks/smart-ui/smart-ui-manager";
import Init from "slotworks/state-machine/standard/states/init";
import deviceInfo from "slotworks/utils/device-info";
import gameiom from "../../gameiom/gameiom";

export default class AGSInit extends Init {

    public onEnter() {
        gameiom.setupServices();

        super.onEnter();
    }

    public complete() {
        const gameplay = GameState.getCurrentGame();
        gameWrapper.balancesUpdate(
            gameplay.realBalance,
            gameplay.freeBalance
        );
        gameWrapper.stakeUpdate(BetModel.getTotalStake());
        if (gameplay.getCurrentRecord()) {
            gameWrapper.winningsUpdate(gameplay.getCurrentRecord().cashWon);
        } else {
            gameWrapper.winningsUpdate(0);
        }

        gameWrapper.gameLoadingEnded();

        super.complete();
    }

    protected setupStateControls() {
        if (!AutoplayModel.enabled) {
            SetupStandardStateControlsCommand("default_noautoplay", "skip_noautoplay", "freespins_noautoplay");
        } else {
            SetupStandardStateControlsCommand();
        }

        if (deviceInfo.layoutId === "mobile") {
            const smartButtonsToHideDuringPrompts = [
                "auto",
                "default",
                "default_noautoplay",
                "skip",
                "skip_noautoplay",
                "freespins",
                "freespins_noautoplay"
            ];

            smartButtonsToHideDuringPrompts.forEach((smartButton) => {
                const uiGroup = SmartUiManager.get(`SmartButton_${smartButton}`);
                if (uiGroup) {
                    SmartUiManager.addAutoHideGroupCondition(uiGroup, [SmartUIFlag.PROMPT]);
                    SmartUiManager.addAutoHideGroupCondition(uiGroup, [SmartUIFlag.MENU]);
                }
            });
        }
    }

    protected enableSound() {
        this.setupGameComponents();

        return SoundPromptCommand("sound_prompt", true, true);
    }

    protected setupGameComponents() {
        const spinRecord = GameState.getCurrentGame().getRootRecord() as SpinRecord;

        if (spinRecord.grid) {
            Components.matrix.jumpToGrid(spinRecord.grid);
        }
    }
}
